<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<div *ngIf="dataIsLoaded && supportedLocale">
  <!--home page-->
  <div class="tech-cn" *ngIf="src == 'technology-cn'">
    <h2 class="text-center" [innerHTML]="data.heading"></h2>
    <div class="row tech-baoying" *ngFor="let item of data.technologies; let i = index">
      <div class="{{ i % 2 === 0 ? 'col-md-6' : 'col-md-6 order-md-2' }} order-sm-1">
        <img [src]="item.image" class="img-fluid" [alt]="item.alt" />
      </div>
      <div class="{{ i % 2 === 0 ? 'col-md-6' : 'col-md-6 order-md-1' }} order-sm-2 ">
        <div class="tech-item">
          <h3 [innerHTML]="item.heading1"></h3>
          <div class="text2" [innerHTML]="item.text2"></div>
        </div>
        <div class="tech-item">
          <h3 [innerHTML]="item.heading2"></h3>
          <div class="text3" [innerHTML]="item.text3"></div>
        </div>
        <div class="card-link">
          <a href="{{ item.linkUrl }}" class="btn btn-primary" target="{{ item.target }}">
            {{ item.linkText }}
          </a>
        </div>
      </div>
    </div>
  </div>
  <!--today baoying page-->
  <div class="today-baoying-part" *ngIf="src == 'technology-cn-today-baoying' && data.heading">
    <h2 class="text-center title-h2" [innerHTML]="data.heading"></h2>
    <h4 class="text-center title-h4" [innerHTML]="data.text" *ngIf="false"></h4>
    <div *ngFor="let item of data.projects; index as i">
      <div class="row tech-content {{ i < 2 ? 'content-part1' : 'content-part2' }}" *ngIf="i != 0">
        <div class="{{ i % 2 === 0 ? 'col-md-6' : 'col-md-6 order-md-2' }} order-sm-1">
          <img [src]="item.image" class="images-technology" [alt]="item.alt" />
        </div>
        <div class="{{ i % 2 === 0 ? 'col-md-6' : 'col-md-6 order-md-1' }} order-sm-2">
          <div>
            <h3 class="title-h3" [innerHTML]="item.heading"></h3>
            <div class="text2" [innerHTML]="item.text1"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
